<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("nova-familia") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="voltar"
                >
                    {{ $t("voltar") }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input 
                                :id="generateId(22)"
                                ref="idErpInput"
                                v-model="familia.idfamiliaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!familia.idfamiliaerp"
                                uppercase
                            />
                        </div>
                        
                        <div class="column is-9">
                            <v-input
                                v-model="familia.descricao"
                                :id="'descricao'"
                                placeholder="familia-placeholder"
                                :maxlength="50"
                                title="descricao-familia"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!familia.descricao"
                                ref="descricaoInput"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FamiliaProdutoValidation from "@/services/validations/FamiliaProdutoValidation";
import ProdutoFamiliaService from "@/services/vendas/produto/ProdutoFamiliaService";
import Message from "@/models/Message";

export default {
    data() {
        return {
            service: null,
            validation: null,
            isSaving: false,
            familia: {
                idfamiliaerp: null,
                id: null,
                descricao: null
            },
            msgs: [],
        };
    },
    created() {
        this.service = new ProdutoFamiliaService(this.$http, this.$router);
        this.validation = new FamiliaProdutoValidation(this.msgs);
    },
    methods: {
        voltar() {
            this.$emit("voltar")
        },
        save() {
            this.isSaving = true;
            this.familia = this.mapTosave(this.familia);

            if (this.validation.validate(this.familia, this.$refs)) {
                this.service.save(this.familia)
                    .then((value) => {
                        if (value.message == null) {
                            this.familia.id = value.content.id;

                            this.msgs.push(new Message("success", 'msg-success-cadastrar', true));

                            let objEmit = {
                                'origem': 'familia',
                                'obj': { id: this.familia.id, label: this.familia.descricao } 
                            };

                            setTimeout(() => {
                                this.$emit('sucesso', objEmit);
                            }, 1000);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 500) {
                            this.msgs.push(
                                new Message("alert", e.body.message, true)
                            );
                        } else {
                            console.error("Erro ao salvar: " + e);
                            this.msgs.push(
                                new Message("error", "msg-erro-salvar", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        generateId(numberId) {
            return this.$route.name + "-contato-" + numberId;
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    background-color: $sovis-white;
}
</style>